import * as t from '../types';
import {GET_PARTNERS_FAILED, GET_PARTNERS_REQUEST, GET_PARTNERS_SUCCESS} from "../types";

const initialState = {
    data: '',
    loading: false,
    error: ''
};

export default function partnersReducer(state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case t.GET_PARTNERS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case t.GET_PARTNERS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload.data
            };
        case t.GET_PARTNERS_FAILED:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
